import { useEffect } from 'react';
import { getIdentityToken } from 'common/utils/getIdentityToken';
import { useOperations as useAuthOperations } from 'store/features/auth';
import { useApplicationOperations } from 'entities/application';
import deleteParamFromUrl from 'common/utils/deleteParamFromUrl';
import deleteClientIdFromUrl from 'common/utils/deleteClientIdFromUrl';
import { getResfreshToken as getLocalRefreshToken } from 'common/utils/auth/refreshToken';
import { getClientId } from 'common/utils/getClientId';
import { USER_TYPES } from 'common/utils/userTypes';
import { MODALS } from 'entities/application';

const useAuth = () => {
  const { loginByIdentityToken, getRefreshToken, setUserType } = useAuthOperations();
  const { setActiveModals } = useApplicationOperations();

  useEffect(() => {
    const auth = async () => {
      const urlIdentityToken = getIdentityToken();
      const refreshToken = getLocalRefreshToken();
      const urlClientId = getClientId();

      if (urlIdentityToken) {
        deleteParamFromUrl('identityToken');
        deleteClientIdFromUrl();
        const authData = await loginByIdentityToken(urlIdentityToken, urlClientId);
        if (!authData) {
          setActiveModals([MODALS.logIn]);
        }
      }

      if (!urlIdentityToken && refreshToken) {
        const authData = await getRefreshToken();
        if (!authData) {
          setActiveModals([MODALS.logIn]);
        }
      }

      if (!urlIdentityToken && !refreshToken) {
        setUserType(USER_TYPES.unautorized);
        setActiveModals([MODALS.logIn]);
      }
    };

    auth();
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useAuth;
